import { render, staticRenderFns } from "./TableListBusinessUnit.vue?vue&type=template&id=4dd56d10"
import script from "./TableListBusinessUnit.vue?vue&type=script&lang=js"
export * from "./TableListBusinessUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dd56d10')) {
      api.createRecord('4dd56d10', component.options)
    } else {
      api.reload('4dd56d10', component.options)
    }
    module.hot.accept("./TableListBusinessUnit.vue?vue&type=template&id=4dd56d10", function () {
      api.rerender('4dd56d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableListBusinessUnit.vue"
export default component.exports